// extracted by mini-css-extract-plugin
export default {"clock":"clock_clock__xF3Lu"};